import { render, staticRenderFns } from "./ModalSelectSerial.vue?vue&type=template&id=ed0bbda2&scoped=true"
import script from "./ModalSelectSerial.vue?vue&type=script&lang=js"
export * from "./ModalSelectSerial.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectSerial.vue?vue&type=style&index=0&id=ed0bbda2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0bbda2",
  null
  
)

export default component.exports